export default __webpack_public_path__ + "static/media/spinner.22d89fae.gif";